/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ellipses_Replacement_CompleteInputs */



/**
* | output |
* | --- |
* | "Ellipses replacement complete" |
*
* @param {Ellipses_Replacement_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ellipses_replacement_complete = /** @type {((inputs?: Ellipses_Replacement_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ellipses_Replacement_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacement par les points de suspension terminé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ellipsenaustausch komplett")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituzione ellissi completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полная замена эллипсов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazo de elipses completo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("椭圆替换完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("楕円の置き換えが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दीर्घवृत्त प्रतिस्थापन पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituição das elipses concluída")
	return /** @type {LocalizedString} */ ("Ellipses replacement complete")
});